<template>
  <div class="cmp-contacts-contacts-contact_sidewindow-invoice_list dbox">
    <NTable
      id="contacts-contacts-contact_sidewindow-invoice_list"
      class="h2 c2 p0 dbox1"
      :headers="invoiceHeaders"
      :items="filteredInvoices"
      :config="invoiceTableConfig"
    >
      <template v-slot:thead="{ thcon, thtext }">
        <tr>
          <th
            v-for="(header, index) in invoiceHeaders"
            v-bind="thcon(header.value)"
            :key="header.value"
          >
            <div v-if="index !== invoiceHeaders.length - 1" class="header-name">
              {{ thtext(header.value) }}
            </div>
            <div v-else>
              <Dropdown
                class="dt-dropdown"
                :options="invoiceStatusTV"
                :selected="invoiceStatusTV.find(c => c.value == selectedStatus)"
                :placeholder="$t('status')"
                v-on:selectedChange="e => onDropdownChange('status', e)"
                deselect
                :listHeight="140"
              >
                <template v-slot:item="{ item }">
                  <div class="ut-flex status status-dropdown">
                    <div
                      class="status-color large"
                      :style="{
                        backgroundColor: `#${item.value}`
                      }"
                    ></div>
                    <div class="status-text">
                      {{ item.text }}
                    </div>
                  </div>
                </template></Dropdown
              >
            </div>
          </th>
        </tr>
      </template>
      <template v-slot:item="{ item, tdcon }">
        <tr
          @click="onInvoiceClicked(item)"
          :title="'Click to see Contact Details'"
        >
          <td v-bind="tdcon(invoiceCostNoHeader)">
            <span class="ut-link ut-text-accent5">{{
              item[invoiceCostNoKey]
            }}</span>
          </td>
          <td v-bind="tdcon('date')">
            <span>{{ item["invoice_date"] }}</span>
          </td>
          <td v-bind="tdcon('amount')">
            <span class="txtov">{{ $dft.curr(item["amount"]) }}</span>
          </td>
          <td v-bind="tdcon('status')">
            <div class="ut-flex">
              <div
                class="status-color"
                :style="{
                  'background-color': getInvoiceStatColor(item['status_color'])
                }"
              ></div>
              <div class="status-text">
                {{ statusText(item["status_color"]) }}
              </div>
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </div>
</template>

<script>
import Dropdown from "@plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";
import { EventHooks } from "../../../../plugins/text-field";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import {
  costListLDTRoutes,
  invoiceListLDTRoutes
} from "../../../accounting/router/routes";
import { routeWithFrom } from "../../../../utility/route";
import { getInvoiceStatColor } from '../../../accounting/models/color-status';

export default {
  components: {
    Dropdown,
    NTable
  },
  props: {
    accountingInfo: {
      type: Object,
      required: true
    },
    invoiceKey: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      invoiceTableConfig: createNTableConfig({
        headerStyle: 2,
        fullHeight: true
      }),
      selectedStatus: null
    };
  },
  computed: {
    invoiceCostNoHeader: function() {
      return isInvoiceKeyInvoices(this.invoiceKey) ? "invoice_no" : "cost";
    },
    invoiceCostNoKey: function() {
      return isInvoiceKeyInvoices(this.invoiceKey)
        ? "invoice_ref"
        : "external_ref";
    },
    invoiceHeaders: function() {
      return [
        createTableHeader(this.invoiceCostNoHeader, {
          f: 0.2
        }),
        createTableHeader("date", { f: 0.15 }),
        createTableHeader("amount", { f: 0.2, ta: "right" }),
        createTableHeader("status", { f: 0.45, ta: "left" })
      ];
    },
    invoiceStatusTV: function() {
      return (this.accountingInfo.invoice_status || []).map(is => {
        return {
          text: this.$t(is[0]),
          value: this.$t(is[1])
        };
      });
    },
    filteredInvoices: function() {
      return (this.accountingInfo[this.invoiceKey] || []).filter(e => {
        if (this.selectedStatus) {
          if (e.status_color == `#${this.selectedStatus}`) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });
    }
  },
  methods: {
    getInvoiceStatColor: getInvoiceStatColor,
    onDropdownChange: function(name, value) {
      switch (name) {
        case "status": {
          this.selectedStatus = value.value;
        }
      }
    },
    onInvoiceClicked: function(item) {
      console.log(item);
      const { invoice_id } = item;
      if (isInvoiceKeyInvoices(this.invoiceKey)) {
        routeWithFrom(this, {
          name: invoiceListLDTRoutes.names.tab,
          params: {
            invoice_id,
            tab: "overview"
          }
        });
      } else {
        this.$router.push({
          name: costListLDTRoutes.names.tab,
          params: {
            invoice_id,
            tab: "overview"
          }
        });
      }
    },
    statusText: function(value) {
      return this.$t(
        this.accountingInfo.invoice_status.find(
          e => e[1] == value.slice(1)
        )?.[0]
      );
    }
    // MARK: Methods
  }
};

const invoiceKeys = ["invoices", "costs"];

const isInvoiceKeyInvoices = key => key == "invoices";
const isInvoiceKeyCosts = key => key == "costs";
</script>

<style lang="scss" scoped>
.status {
  align-items: start;
  min-width: 120px;
  &.status-dropdown {
    align-items: center;
  }
  .status-color {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    &.large {
      width: 13px;
      height: 13px;
      // box-shadow: #fff 0 0 0 2px;
    }
  }
  .status-text {
    margin-left: 10px;
  }
}
</style>

<style lang="scss">
.cmp-contacts-contacts-contact_sidewindow-invoice_list {
  .dt-ntable {
    th {
      &.amount {
        text-align: right;
      }
    }
    .dropdown .dropdown--main .dropdown--main__text {
      flex: auto;
      margin-right: 7px;
    }
    // td:nth-child(4) {
    //   align-items: left;
    //   .status-color {
    //     margin-left: 15px !important;
    //   }
    // }
    // th:nth-child(4),
    // td:nth-child(4) {
    //   flex: 0.3 0 50px;
    //   .dt-dropdown {
    //     /* margin: 5px 5px !important; */
    //     margin-left: 10px;
    //     max-width: 150px;
    //   }
    // }

    // @media screen and (min-width: 320px) and (max-width: 480px) {
    //   th:nth-child(4),
    //   td:nth-child(4) {
    //     flex: 0.3 0 50px;
    //     .dt-dropdown {
    //       width: 40px;
    //       max-width: 200px;
    //     }
    //   }
    // }
  }
}
</style>
